import { IClaimDetails } from '../types';

export const getCashlessPayload = (data: IClaimDetails) => {
  return {
    claim_details: {
      plumClaimId: {
        description: 'This is the claimId',
        value: data?.plumClaimId ?? null,
      },
      requestedClaimAmount: {
        description: 'This is the treatment amount requested by the hospital',
        value: data?.amount === '0' ? null : data?.amount ?? null,
      },
      approvedClaimAmountForCurrentStage: {
        description:
          'This is the amount approved by the insurer for the current stage.',
        value: data?.amountApproved ?? null,
      },
      currentStage: {
        description: 'This is the current stage of the cashless claim.',
        value: data?.stage ?? null,
      },
      currentStageDate: {
        description:
          'This is the date and time at which the current stage happened',
        value: data?.fullfilled?.[data?.stage]?.date ?? null,
      },
      approvalLetterURL: {
        description: 'This is the approval letter from the insurer',
        value: null,
      },
      cashlessClaimRejectionReasonByInsurer: {
        description:
          'This is the reason for the rejection of the cashless claim by the insurer.',
        value: data?.insurerRejectionReason ?? null,
      },
      nextExpectedStage: {
        description: 'This is the next expected stage of the cashless claim.',
        value: data?.nextExpectedStage ?? null,
      },
      nextExpectedStageDate: {
        description:
          'This is the dateTime at which the claim would progress to next expected stage.',
        value: data?.nextExpectedStageDate ?? null,
      },
    },
  };
};
